import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge34 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の相続税評価・計算方法（具体例つき）' fontWeight={700} />
                <p>
                    ゴルフ会員権の相続手続きの流れや必要書類については
                    <a href='/knowledge/6'>ゴルフ会員権の相続</a>
                    ですでにご紹介していますが、実際に相続税を計算する際には「評価額をどう算出すればよいか」が最大の関門になります。
                    <br />
                    本記事では、国税庁の財産評価基本通達211に基づく評価方法を、具体的な計算例とあわせて解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='評価方法の原則（財産評価基本通達211）' fontWeight={700} />
                <p>ゴルフ会員権の相続税評価は、会員権の形態と取引相場の有無によって、大きく3パターンに分かれます。</p>

                <Heading3 title='①取引相場のある会員権' />
                <p>
                    相続開始時点の通常の取引価格の70％相当額に、取引価格に含まれていない預託金等（返還を受けられる金額）を加算して評価します。
                    <br />
                    取引価格をそのまま使わず70％を乗じるのは、実際に会員権を売却する際には仲介手数料などのコストがかかることを考慮したものです。
                </p>

                <Heading3 title='②取引相場のない会員権（株主会員制）' />
                <p>
                    株主会員制のクラブで取引相場がない場合は、そのゴルフ会員権に係る株式部分を、非上場株式（取引相場のない株式）と同様の方法で評価し、預託金等がある場合はその評価額を加算します。
                </p>

                <Heading3 title='③取引相場のない会員権（預託金会員制・プレー権のみ）' />
                <p>
                    株主部分を持たない預託金会員制で取引相場がない場合は、返還を受けられる預託金等の額のみで評価します。
                    <br />
                    なお、譲渡できず、かつ返還を受けられる預託金等も無い、プレーする権利のみの会員権については、財産的価値が無いものとして評価しません（評価額0円）。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='具体例で計算してみる' fontWeight={700} />

                <Heading3 title='ケース1：取引相場があり、預託金をすぐに返還請求できる場合' />
                <p>
                    相続開始時点の取引価格が200万円、据置期間が満了しすぐに返還請求できる預託金が100万円ある場合。
                    <br />
                    200万円×70％＝140万円（取引相場部分の評価額）
                    <br />
                    140万円＋100万円（預託金）＝240万円（相続税評価額）
                </p>

                <Heading3 title='ケース2：取引相場があり、預託金の据置期間がまだ残っている場合' />
                <p>
                    相続開始時点の取引価格が150万円、返還までまだ据置期間が残っている預託金が50万円ある場合。
                    <br />
                    取引相場部分は150万円×70％＝105万円ですが、預託金部分は額面の50万円をそのまま加算するのではなく、返還を受けられる日までの期間に応じた基準年利率による複利現価の額を加算します。
                    <br />
                    基準年利率は国税庁が毎年（原則として月ごとに）公表しており、据置期間が長いほど現在価値としての評価額は額面より小さくなります。具体的な現価額は、相続開始時点で公表されている最新の基準年利率と複利現価表を使って算出する必要があるため、申告時に国税庁のウェブサイトで最新の数値を確認するか、税理士に確認することをおすすめします。
                </p>

                <Heading3 title='ケース3：株主会員制で取引相場がない場合' />
                <p>
                    株式部分を非上場株式の評価方法で評価した結果が80万円、預託金等の評価額が100万円だった場合。
                    <br />
                    80万円＋100万円＝180万円（相続税評価額）
                    <br />
                    非上場株式の評価は、会社の規模や純資産価額などをもとに複数の方式（類似業種比準方式・純資産価額方式など）を組み合わせて算定する専門性の高い計算になるため、実務では税理士による評価が前提になります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='相続税申告におけるゴルフ会員権の取り扱い' fontWeight={700} />
                <p>
                    相続税の申告期限は、原則として相続の開始があったことを知った日の翌日から10か月以内です。ゴルフ会員権も他の相続財産と合算して申告するため、評価額の算定は早めに着手する必要があります。
                    <br />
                    相続したゴルフ会員権をそのまま引き継いでプレーする場合、被相続人から相続人への名義書換の手続きが必要になります。名義書換の具体的な流れや必要書類については
                    <a href='/knowledge/3'>名義書換に関して</a>
                    で詳しくご紹介しています。
                    <br />
                    相続したゴルフ会員権を売却する場合の譲渡所得の計算方法（長期・短期譲渡の区分や特別控除）についても、
                    <a href='/knowledge/6'>ゴルフ会員権の相続</a>にて解説していますのであわせてご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権の相続税評価は、取引相場の有無と会員権の形態によって計算方法が異なり、預託金の据置期間によっては複利現価の計算も必要になるため、一般の方が正確に算出するのは容易ではありません。
                    <br />
                    評価額の算定に不安がある場合は税理士に、相続後の名義書換や売却については会員権業者にそれぞれ相談することで、手続きをスムーズに進めることができます。ゴルフ会員権の相続に関するご相談は、住地ゴルフまでお気軽にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge34;
